import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TrailerViewModel, TrailerStatus } from "@app/shared/models/trailers/TrailerViewModel.model";
import { TractorStatus } from "@app/shared/models/tractors/TractorViewModel.model";

@Component({
  selector: "app-trailer-maintenance",
  templateUrl: "./trailer-maintenance.component.html",
  styleUrls: ["./trailer-maintenance.component.css"],
})
export class TrailerMaintenanceComponent implements OnInit, OnChanges {
  @Input() trailer: TrailerViewModel;
  @Input() isEditMode: boolean;
  @Input() dateInputMask: any;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTrailer: string;
  trailerStatuses = TractorStatus;
  trailerStatusOptions = [
    { value: TractorStatus.Available, label: "Available" },
    { value: TractorStatus.Shop, label: "Shop" },
    { value: TractorStatus.OOS, label: "OOS" }
  ];

  constructor() {}

  ngOnInit() {
    this.originalTrailer = JSON.stringify(this.trailer);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["trailer"] && !changes["trailer"].firstChange) {
      this.originalTrailer = JSON.stringify(this.trailer);
      this.checkForChanges();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentTrailer = JSON.stringify(this.trailer);
    const changed = currentTrailer !== this.originalTrailer;
    this.hasChanges.emit(changed);
  }

  getTrailerStatusLabel(): string {
    if (this.trailer?.status === undefined || this.trailer?.status === null) {
      return "Available";
    }
    const status = this.trailerStatusOptions.find(opt => opt.value === this.trailer.status);
    return status ? status.label : "Available";
  }

  getStatusPillClass(): string {
    if (this.trailer?.status === undefined || this.trailer?.status === null) {
      return "status-pill status-in-service";
    }
    if (this.trailer.status === TractorStatus.Available) {
      return "status-pill status-in-service";
    } else if (this.trailer.status === TractorStatus.Shop) {
      return "status-pill status-out-of-service";
    } else if (this.trailer.status === TractorStatus.OOS) {
      return "status-pill status-out-of-service";
    }
    return "status-pill status-in-service";
  }
}
